import { OnboardingStep } from "@src/gql/graphql";
import { z } from "zod";

export const onboardingStepSchema = z.object({
	isCompleted: z.boolean(),
	step: z.nativeEnum(OnboardingStep),
	updatedAt: z.string().nullable().optional(),
});

export const onboardingOverviewSchema = z.object({
	createdAt: z.string().nullable().optional(),
	id: z.string(),
	position: z.number(),
	streamPosition: z.number(),
	updatedAt: z.string().nullable().optional(),
	steps: z.array(onboardingStepSchema),
});

export const completeOnboardingStepSchema = z.object({
	steps: z.array(
		z.object({
			key: z.nativeEnum(OnboardingStep),
			value: z.object({
				isCompleted: z.boolean(),
			}),
		}),
	),
});
